import { Navigate, Outlet } from 'react-router';
import type { RoutePermission } from '../../config/route-permission-map';
import { usePermissions } from '../../hooks/use-permissions';
import { isGuardQuerySettling } from './guard-query-state';

interface PermissionGuardProps {
  permission: RoutePermission;
  redirectTo?: string;
}

export function PermissionGuard({ permission, redirectTo = '/home' }: PermissionGuardProps) {
  const { hasPermission, isPending, fetchStatus } = usePermissions();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }
  const permissions = Array.isArray(permission) ? permission : [permission];
  if (!permissions.every(hasPermission)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
